import Long from "long";
import _m0 from "protobufjs/minimal";
import { AppLaunchType } from "./app_launch_type";
import { ContactAuthorizationStatus } from "./contact_authorization_status";
export const protobufPackage = "snapchat.cdp.cof";
export interface BillboardSignals {
    emailVerified: boolean;
    phoneVerified: boolean;
    notificationPermGranted: boolean;
    contactPermGranted: boolean;
    mutualFriendsCount: number;
    groupsCount: number;
    hasNonTeamSnapchatConversations: boolean;
    emailSet: boolean;
    bitmojiSet: boolean;
    hasAddFriendsRequest: boolean;
    appLaunchFromPush: boolean;
    appLaunchType: AppLaunchType;
    campaignLocalImpressionCount: number;
    campaignLocalLastImpressionTimeSecsToNow: string;
    campaignLocalContinuousDismissCount: number;
    fstNumInAppWarnings: number;
    fstShouldChangePassword: boolean;
    audioRecordPermGranted: boolean;
    mutualFriendsWithBirthdayCount: number;
    campaignLocalDismissCount: number;
    memoriesCount: number;
    campaignLocalFirstImpressionTimeSecsToNow: string;
    campaignLocalClickCount: number;
    campaignLocalInteractionCount: number;
    campaignLocalLastInteractionTimeSecsToNow: string;
    lockScreenWidgetAppOpenFromPush: boolean;
    communityCount: number;
    campaignLocalFirstClickTimeSecsToNow: string;
    campaignLocalLastClickTimeSecsToNow: string;
    campaignLocalFirstDismissTimeSecsToNow: string;
    campaignLocalLastDismissTimeSecsToNow: string;
    campaignLocalFirstInteractionTimeSecsToNow: string;
    serverImpressionCount: number;
    serverClickCount: number;
    serverDismissCount: number;
    serverInteractionCount: number;
    serverFirstImpressionTimeSecsToNow: string;
    serverLastImpressionTimeSecsToNow: string;
    serverFirstClickTimeSecsToNow: string;
    serverLastClickTimeSecsToNow: string;
    serverFirstDismissTimeSecsToNow: string;
    serverLastDismissTimeSecsToNow: string;
    serverFirstInteractionTimeSecsToNow: string;
    serverLastInteractionTimeSecsToNow: string;
    serverContinuousDismissCount: number;
    contactPermOsGranted: boolean;
    contactPermUserGranted: boolean;
    contactPermOsAuthorizationStatus: ContactAuthorizationStatus;
}
function createBaseBillboardSignals(): BillboardSignals {
    return {
        emailVerified: false,
        phoneVerified: false,
        notificationPermGranted: false,
        contactPermGranted: false,
        mutualFriendsCount: 0,
        groupsCount: 0,
        hasNonTeamSnapchatConversations: false,
        emailSet: false,
        bitmojiSet: false,
        hasAddFriendsRequest: false,
        appLaunchFromPush: false,
        appLaunchType: 0,
        campaignLocalImpressionCount: 0,
        campaignLocalLastImpressionTimeSecsToNow: "0",
        campaignLocalContinuousDismissCount: 0,
        fstNumInAppWarnings: 0,
        fstShouldChangePassword: false,
        audioRecordPermGranted: false,
        mutualFriendsWithBirthdayCount: 0,
        campaignLocalDismissCount: 0,
        memoriesCount: 0,
        campaignLocalFirstImpressionTimeSecsToNow: "0",
        campaignLocalClickCount: 0,
        campaignLocalInteractionCount: 0,
        campaignLocalLastInteractionTimeSecsToNow: "0",
        lockScreenWidgetAppOpenFromPush: false,
        communityCount: 0,
        campaignLocalFirstClickTimeSecsToNow: "0",
        campaignLocalLastClickTimeSecsToNow: "0",
        campaignLocalFirstDismissTimeSecsToNow: "0",
        campaignLocalLastDismissTimeSecsToNow: "0",
        campaignLocalFirstInteractionTimeSecsToNow: "0",
        serverImpressionCount: 0,
        serverClickCount: 0,
        serverDismissCount: 0,
        serverInteractionCount: 0,
        serverFirstImpressionTimeSecsToNow: "0",
        serverLastImpressionTimeSecsToNow: "0",
        serverFirstClickTimeSecsToNow: "0",
        serverLastClickTimeSecsToNow: "0",
        serverFirstDismissTimeSecsToNow: "0",
        serverLastDismissTimeSecsToNow: "0",
        serverFirstInteractionTimeSecsToNow: "0",
        serverLastInteractionTimeSecsToNow: "0",
        serverContinuousDismissCount: 0,
        contactPermOsGranted: false,
        contactPermUserGranted: false,
        contactPermOsAuthorizationStatus: 0,
    };
}
export const BillboardSignals = {
    encode(message: BillboardSignals, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.emailVerified === true) {
            writer.uint32(8).bool(message.emailVerified);
        }
        if (message.phoneVerified === true) {
            writer.uint32(16).bool(message.phoneVerified);
        }
        if (message.notificationPermGranted === true) {
            writer.uint32(24).bool(message.notificationPermGranted);
        }
        if (message.contactPermGranted === true) {
            writer.uint32(32).bool(message.contactPermGranted);
        }
        if (message.mutualFriendsCount !== 0) {
            writer.uint32(40).int32(message.mutualFriendsCount);
        }
        if (message.groupsCount !== 0) {
            writer.uint32(48).int32(message.groupsCount);
        }
        if (message.hasNonTeamSnapchatConversations === true) {
            writer.uint32(56).bool(message.hasNonTeamSnapchatConversations);
        }
        if (message.emailSet === true) {
            writer.uint32(64).bool(message.emailSet);
        }
        if (message.bitmojiSet === true) {
            writer.uint32(72).bool(message.bitmojiSet);
        }
        if (message.hasAddFriendsRequest === true) {
            writer.uint32(80).bool(message.hasAddFriendsRequest);
        }
        if (message.appLaunchFromPush === true) {
            writer.uint32(88).bool(message.appLaunchFromPush);
        }
        if (message.appLaunchType !== 0) {
            writer.uint32(96).int32(message.appLaunchType);
        }
        if (message.campaignLocalImpressionCount !== 0) {
            writer.uint32(104).int32(message.campaignLocalImpressionCount);
        }
        if (message.campaignLocalLastImpressionTimeSecsToNow !== "0") {
            writer.uint32(112).int64(message.campaignLocalLastImpressionTimeSecsToNow);
        }
        if (message.campaignLocalContinuousDismissCount !== 0) {
            writer.uint32(120).int32(message.campaignLocalContinuousDismissCount);
        }
        if (message.fstNumInAppWarnings !== 0) {
            writer.uint32(128).int32(message.fstNumInAppWarnings);
        }
        if (message.fstShouldChangePassword === true) {
            writer.uint32(136).bool(message.fstShouldChangePassword);
        }
        if (message.audioRecordPermGranted === true) {
            writer.uint32(144).bool(message.audioRecordPermGranted);
        }
        if (message.mutualFriendsWithBirthdayCount !== 0) {
            writer.uint32(152).int32(message.mutualFriendsWithBirthdayCount);
        }
        if (message.campaignLocalDismissCount !== 0) {
            writer.uint32(160).int32(message.campaignLocalDismissCount);
        }
        if (message.memoriesCount !== 0) {
            writer.uint32(168).int32(message.memoriesCount);
        }
        if (message.campaignLocalFirstImpressionTimeSecsToNow !== "0") {
            writer.uint32(176).int64(message.campaignLocalFirstImpressionTimeSecsToNow);
        }
        if (message.campaignLocalClickCount !== 0) {
            writer.uint32(184).int32(message.campaignLocalClickCount);
        }
        if (message.campaignLocalInteractionCount !== 0) {
            writer.uint32(192).int32(message.campaignLocalInteractionCount);
        }
        if (message.campaignLocalLastInteractionTimeSecsToNow !== "0") {
            writer.uint32(200).int64(message.campaignLocalLastInteractionTimeSecsToNow);
        }
        if (message.lockScreenWidgetAppOpenFromPush === true) {
            writer.uint32(208).bool(message.lockScreenWidgetAppOpenFromPush);
        }
        if (message.communityCount !== 0) {
            writer.uint32(216).int32(message.communityCount);
        }
        if (message.campaignLocalFirstClickTimeSecsToNow !== "0") {
            writer.uint32(224).int64(message.campaignLocalFirstClickTimeSecsToNow);
        }
        if (message.campaignLocalLastClickTimeSecsToNow !== "0") {
            writer.uint32(232).int64(message.campaignLocalLastClickTimeSecsToNow);
        }
        if (message.campaignLocalFirstDismissTimeSecsToNow !== "0") {
            writer.uint32(240).int64(message.campaignLocalFirstDismissTimeSecsToNow);
        }
        if (message.campaignLocalLastDismissTimeSecsToNow !== "0") {
            writer.uint32(248).int64(message.campaignLocalLastDismissTimeSecsToNow);
        }
        if (message.campaignLocalFirstInteractionTimeSecsToNow !== "0") {
            writer.uint32(256).int64(message.campaignLocalFirstInteractionTimeSecsToNow);
        }
        if (message.serverImpressionCount !== 0) {
            writer.uint32(264).int32(message.serverImpressionCount);
        }
        if (message.serverClickCount !== 0) {
            writer.uint32(272).int32(message.serverClickCount);
        }
        if (message.serverDismissCount !== 0) {
            writer.uint32(280).int32(message.serverDismissCount);
        }
        if (message.serverInteractionCount !== 0) {
            writer.uint32(288).int32(message.serverInteractionCount);
        }
        if (message.serverFirstImpressionTimeSecsToNow !== "0") {
            writer.uint32(296).int64(message.serverFirstImpressionTimeSecsToNow);
        }
        if (message.serverLastImpressionTimeSecsToNow !== "0") {
            writer.uint32(304).int64(message.serverLastImpressionTimeSecsToNow);
        }
        if (message.serverFirstClickTimeSecsToNow !== "0") {
            writer.uint32(312).int64(message.serverFirstClickTimeSecsToNow);
        }
        if (message.serverLastClickTimeSecsToNow !== "0") {
            writer.uint32(320).int64(message.serverLastClickTimeSecsToNow);
        }
        if (message.serverFirstDismissTimeSecsToNow !== "0") {
            writer.uint32(328).int64(message.serverFirstDismissTimeSecsToNow);
        }
        if (message.serverLastDismissTimeSecsToNow !== "0") {
            writer.uint32(336).int64(message.serverLastDismissTimeSecsToNow);
        }
        if (message.serverFirstInteractionTimeSecsToNow !== "0") {
            writer.uint32(344).int64(message.serverFirstInteractionTimeSecsToNow);
        }
        if (message.serverLastInteractionTimeSecsToNow !== "0") {
            writer.uint32(352).int64(message.serverLastInteractionTimeSecsToNow);
        }
        if (message.serverContinuousDismissCount !== 0) {
            writer.uint32(360).int32(message.serverContinuousDismissCount);
        }
        if (message.contactPermOsGranted === true) {
            writer.uint32(368).bool(message.contactPermOsGranted);
        }
        if (message.contactPermUserGranted === true) {
            writer.uint32(376).bool(message.contactPermUserGranted);
        }
        if (message.contactPermOsAuthorizationStatus !== 0) {
            writer.uint32(384).int32(message.contactPermOsAuthorizationStatus);
        }
        return writer;
    },
    decode(input: _m0.Reader | Uint8Array, length?: number): BillboardSignals {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBillboardSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.emailVerified = reader.bool();
                    break;
                case 2:
                    message.phoneVerified = reader.bool();
                    break;
                case 3:
                    message.notificationPermGranted = reader.bool();
                    break;
                case 4:
                    message.contactPermGranted = reader.bool();
                    break;
                case 5:
                    message.mutualFriendsCount = reader.int32();
                    break;
                case 6:
                    message.groupsCount = reader.int32();
                    break;
                case 7:
                    message.hasNonTeamSnapchatConversations = reader.bool();
                    break;
                case 8:
                    message.emailSet = reader.bool();
                    break;
                case 9:
                    message.bitmojiSet = reader.bool();
                    break;
                case 10:
                    message.hasAddFriendsRequest = reader.bool();
                    break;
                case 11:
                    message.appLaunchFromPush = reader.bool();
                    break;
                case 12:
                    message.appLaunchType = reader.int32() as any;
                    break;
                case 13:
                    message.campaignLocalImpressionCount = reader.int32();
                    break;
                case 14:
                    message.campaignLocalLastImpressionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 15:
                    message.campaignLocalContinuousDismissCount = reader.int32();
                    break;
                case 16:
                    message.fstNumInAppWarnings = reader.int32();
                    break;
                case 17:
                    message.fstShouldChangePassword = reader.bool();
                    break;
                case 18:
                    message.audioRecordPermGranted = reader.bool();
                    break;
                case 19:
                    message.mutualFriendsWithBirthdayCount = reader.int32();
                    break;
                case 20:
                    message.campaignLocalDismissCount = reader.int32();
                    break;
                case 21:
                    message.memoriesCount = reader.int32();
                    break;
                case 22:
                    message.campaignLocalFirstImpressionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 23:
                    message.campaignLocalClickCount = reader.int32();
                    break;
                case 24:
                    message.campaignLocalInteractionCount = reader.int32();
                    break;
                case 25:
                    message.campaignLocalLastInteractionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 26:
                    message.lockScreenWidgetAppOpenFromPush = reader.bool();
                    break;
                case 27:
                    message.communityCount = reader.int32();
                    break;
                case 28:
                    message.campaignLocalFirstClickTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 29:
                    message.campaignLocalLastClickTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 30:
                    message.campaignLocalFirstDismissTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 31:
                    message.campaignLocalLastDismissTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 32:
                    message.campaignLocalFirstInteractionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 33:
                    message.serverImpressionCount = reader.int32();
                    break;
                case 34:
                    message.serverClickCount = reader.int32();
                    break;
                case 35:
                    message.serverDismissCount = reader.int32();
                    break;
                case 36:
                    message.serverInteractionCount = reader.int32();
                    break;
                case 37:
                    message.serverFirstImpressionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 38:
                    message.serverLastImpressionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 39:
                    message.serverFirstClickTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 40:
                    message.serverLastClickTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 41:
                    message.serverFirstDismissTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 42:
                    message.serverLastDismissTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 43:
                    message.serverFirstInteractionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 44:
                    message.serverLastInteractionTimeSecsToNow = longToString(reader.int64() as Long);
                    break;
                case 45:
                    message.serverContinuousDismissCount = reader.int32();
                    break;
                case 46:
                    message.contactPermOsGranted = reader.bool();
                    break;
                case 47:
                    message.contactPermUserGranted = reader.bool();
                    break;
                case 48:
                    message.contactPermOsAuthorizationStatus = reader.int32() as any;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial<I extends Exact<DeepPartial<BillboardSignals>, I>>(object: I): BillboardSignals {
        const message = createBaseBillboardSignals();
        message.emailVerified = object.emailVerified ?? false;
        message.phoneVerified = object.phoneVerified ?? false;
        message.notificationPermGranted = object.notificationPermGranted ?? false;
        message.contactPermGranted = object.contactPermGranted ?? false;
        message.mutualFriendsCount = object.mutualFriendsCount ?? 0;
        message.groupsCount = object.groupsCount ?? 0;
        message.hasNonTeamSnapchatConversations = object.hasNonTeamSnapchatConversations ?? false;
        message.emailSet = object.emailSet ?? false;
        message.bitmojiSet = object.bitmojiSet ?? false;
        message.hasAddFriendsRequest = object.hasAddFriendsRequest ?? false;
        message.appLaunchFromPush = object.appLaunchFromPush ?? false;
        message.appLaunchType = object.appLaunchType ?? 0;
        message.campaignLocalImpressionCount = object.campaignLocalImpressionCount ?? 0;
        message.campaignLocalLastImpressionTimeSecsToNow = object.campaignLocalLastImpressionTimeSecsToNow ?? "0";
        message.campaignLocalContinuousDismissCount = object.campaignLocalContinuousDismissCount ?? 0;
        message.fstNumInAppWarnings = object.fstNumInAppWarnings ?? 0;
        message.fstShouldChangePassword = object.fstShouldChangePassword ?? false;
        message.audioRecordPermGranted = object.audioRecordPermGranted ?? false;
        message.mutualFriendsWithBirthdayCount = object.mutualFriendsWithBirthdayCount ?? 0;
        message.campaignLocalDismissCount = object.campaignLocalDismissCount ?? 0;
        message.memoriesCount = object.memoriesCount ?? 0;
        message.campaignLocalFirstImpressionTimeSecsToNow = object.campaignLocalFirstImpressionTimeSecsToNow ?? "0";
        message.campaignLocalClickCount = object.campaignLocalClickCount ?? 0;
        message.campaignLocalInteractionCount = object.campaignLocalInteractionCount ?? 0;
        message.campaignLocalLastInteractionTimeSecsToNow = object.campaignLocalLastInteractionTimeSecsToNow ?? "0";
        message.lockScreenWidgetAppOpenFromPush = object.lockScreenWidgetAppOpenFromPush ?? false;
        message.communityCount = object.communityCount ?? 0;
        message.campaignLocalFirstClickTimeSecsToNow = object.campaignLocalFirstClickTimeSecsToNow ?? "0";
        message.campaignLocalLastClickTimeSecsToNow = object.campaignLocalLastClickTimeSecsToNow ?? "0";
        message.campaignLocalFirstDismissTimeSecsToNow = object.campaignLocalFirstDismissTimeSecsToNow ?? "0";
        message.campaignLocalLastDismissTimeSecsToNow = object.campaignLocalLastDismissTimeSecsToNow ?? "0";
        message.campaignLocalFirstInteractionTimeSecsToNow = object.campaignLocalFirstInteractionTimeSecsToNow ?? "0";
        message.serverImpressionCount = object.serverImpressionCount ?? 0;
        message.serverClickCount = object.serverClickCount ?? 0;
        message.serverDismissCount = object.serverDismissCount ?? 0;
        message.serverInteractionCount = object.serverInteractionCount ?? 0;
        message.serverFirstImpressionTimeSecsToNow = object.serverFirstImpressionTimeSecsToNow ?? "0";
        message.serverLastImpressionTimeSecsToNow = object.serverLastImpressionTimeSecsToNow ?? "0";
        message.serverFirstClickTimeSecsToNow = object.serverFirstClickTimeSecsToNow ?? "0";
        message.serverLastClickTimeSecsToNow = object.serverLastClickTimeSecsToNow ?? "0";
        message.serverFirstDismissTimeSecsToNow = object.serverFirstDismissTimeSecsToNow ?? "0";
        message.serverLastDismissTimeSecsToNow = object.serverLastDismissTimeSecsToNow ?? "0";
        message.serverFirstInteractionTimeSecsToNow = object.serverFirstInteractionTimeSecsToNow ?? "0";
        message.serverLastInteractionTimeSecsToNow = object.serverLastInteractionTimeSecsToNow ?? "0";
        message.serverContinuousDismissCount = object.serverContinuousDismissCount ?? 0;
        message.contactPermOsGranted = object.contactPermOsGranted ?? false;
        message.contactPermUserGranted = object.contactPermUserGranted ?? false;
        message.contactPermOsAuthorizationStatus = object.contactPermOsAuthorizationStatus ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
function longToString(long: Long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
